import API from './index';

export const getAccess = () => API.get('/access');
